/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore'
], function(_) {

	// implements IValue
	class VIPRValue {
		constructor(valueObj, formatter, resultItemIndex) {
			//accept either { .v or # }
			this.rawValue = valueObj;
			this.value = (valueObj && !_.isNumber(valueObj) && valueObj.v!==undefined) ? valueObj.v : valueObj;

			this.formatter = formatter;
			this.index = resultItemIndex;
		}

		destroy() {
			this.formatter = null;
		}

		getIndex() {
			return this.index;
		}

		getValue() {
			//The value of a VIPRValue is a number (eg 1234.50)
			return this.value;
		}

		getValueType () {
			if (this.value === null) {
				return 'missing'; //NULL Value support, to be parsed by VIDA
			}
			return 'numeric'; //Default Value Type
		}

		getCaption() {
			//The "caption" of a value is its formatted string (eg: $1,234.50)
			return this.formatter ? this.formatter.format(this.value) : this.value;
		}

		/**
		 * This function is not an implementation of IValue
		 * Sole purpose is to give VIPREventTarget to have access to the raw datapoint value
		 */
		getRawValue() {
			return this.rawValue;
		}
	}

	return VIPRValue;
});
